import script from "./reviewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewComponent.vue?vue&type=script&setup=true&lang=js"

import "./reviewComponent.vue?vue&type=style&index=0&id=7b4c1332&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b4c1332"]])

export default __exports__